import { NICmsContentField } from '@icms/core/content';
import { CUSTOMER_GROUPS, customerGroupVisibilityCmsField } from '../../../../customer/groups/customer-groups';

export const ACCESS_RESTRICTION_MODAL_CONFIG = [
    <NICmsContentField.IField>{
        key: 'access_restriction_config',
        type: NICmsContentField.EFieldType.label,
        title: 'Access Restriction Modal Configuration'
    },
    <NICmsContentField.IField>{
        key: 'enableAccessRestriction',
        type: NICmsContentField.EFieldType.toggle,
        title: 'Enable Access Restriction',
        default: false
    },
    {
        ...customerGroupVisibilityCmsField(CUSTOMER_GROUPS),
        key: 'visibility',
        title: 'Customer Group visibility'
    },
    <NICmsContentField.IField>{
        key: 'restrictionTitle',
        type: NICmsContentField.EFieldType.text,
        title: 'Restriction Title'
    },
    <NICmsContentField.IField>{
        key: 'restrictionSubtitle',
        type: NICmsContentField.EFieldType.text,
        title: 'Restriction Subtitle'
    },
    <NICmsContentField.IField>{
        key: 'showAccountCreationLink',
        type: NICmsContentField.EFieldType.toggle,
        title: 'Show Account Creation Link'
    },
    <NICmsContentField.IField>{
        key: 'blurStrength',
        type: NICmsContentField.EFieldType.number,
        min: 0,
        max: 100,
        title: 'Blur Strength'
    },
    <NICmsContentField.IField>{
        key: 'noAccessTitle',
        type: NICmsContentField.EFieldType.text,
        title: 'No Access Title'
    },
    <NICmsContentField.IField>{
        key: 'noAccessSubtitle',
        type: NICmsContentField.EFieldType.text,
        title: 'No Access Subtitle'
    }
];
